import Seo from "@/components/Seo";
import Cta from "@/components/Cta";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found | CYAN Wireless" description="The page you're looking for doesn't exist." path="/404" />
      <section className="min-h-[80vh] grid place-items-center bg-ink-950 pt-24 px-5">
        <div className="text-center">
          <div className="font-display font-black text-[26vw] sm:text-[16rem] leading-none text-white/5 tracking-tighter">404</div>
          <h1 className="font-display font-extrabold text-3xl sm:text-4xl text-white -mt-8 tracking-tighter">Lost the signal.</h1>
          <p className="text-zinc-400 mt-4 mb-8">That page drifted out of range. Let's get you back on the network.</p>
          <Cta to="/">Back Home</Cta>
        </div>
      </section>
    </>
  );
}
